import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { useTranslation } from "../context/LanguageContext";
import { useProductContext } from "../context/ProductContext";

export default function NotFoundPage() {
  const { t } = useTranslation();
  const { selectedProduct } = useProductContext();

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-gradient-to-br from-gray-50 to-gray-100 dark:from-dark-950 dark:to-dark-900 flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        {/* 404 Number */}
        <h1 className="text-8xl font-bold text-primary-600 mb-4">404</h1>

        {/* Error message */}
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-dark-100 mb-3">
          {t("errors.pageNotFound")}
        </h2>
        <p className="text-gray-600 dark:text-dark-300 mb-8">
          {t("errors.pageNotFoundMessage")}
        </p>

        {/* Action buttons */}
        <div className="flex gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-primary-700 transition-colors"
          >
            <Home className="w-4 h-4" />
            {t("errors.goHome")}
          </Link>
          <button
            onPointerDown={() => window.history.back()}
            className="inline-flex items-center gap-2 bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-dark-300 px-6 py-3 rounded-lg font-medium hover:bg-gray-200 dark:hover:bg-dark-600 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            {t("errors.goBack")}
          </button>
        </div>

        {/* Quick links */}
        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-dark-700">
          <div className="flex justify-center gap-6 text-sm">
            <Link
              to="/help"
              className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
            >
              {t("errors.helpCenter")}
            </Link>
            <Link
              to="/settings"
              className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
            >
              {t("common.settings")}
            </Link>
            <Link
              to={`/${selectedProduct}/tracking`}
              className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
            >
              {t("tracking.title")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
